
const ofertaEN = [
    {
        "Construction and Structural Work" :                
        [
            "Construction of single-family homes",
            "Insulation and finishing of attics in single-family homes",
            "Carpentry and roofing work, including roof construction and repair",
            "Traditional and machine plastering, facades",
            "Foundation, load-bearing walls, and other structural construction",
            "Construction of halls and warehouses",
            "Conservation and restoration work on historical buildings"
        ]
    },              
    {
        "Finishing Works" :         
        [   
            "Installation of gypsum board walls and ceilings",
            "Installation of suspended ceilings (linear and cassette)",
            "Traditional and spray painting",
            "Wallpapering, preparatory work, and plastering",
            "Tiling, including the laying of ceramic and terracotta tiles",
            "Interior finishing services, such as custom cabinetry, suspended ceilings, and partition walls",
            "Installation of carpet, click-lock flooring, PVC flooring, and wooden flooring"
        ]
    },
    {
        "Exterior and Roadwork" :
        [
            "Installation of cobblestone and sidewalks",
            "Fence, gate, and gate construction",
            "Dismantling and demolition of building structures",
            "Earthworks and road construction, including road and parking lot construction"
        ]
    },                   
    {
        "Installations and Systems" :               
        [
            "Electrical installations",
            "Computer networks and alarm systems",
            "Plumbing installations and underfloor heating systems",
            "Installation of doors and windows, including aluminum and PVC joinery",
            "Installation of ventilation and air conditioning systems"
        ]
    },
    {
        "Work Related to Energy Modernization" :                 
        [   
            "Building thermal modernization",
            "Thermal insulation",
            "Installation of energy-efficient windows",
            "Exterior renovation"
        ]
    },
]

export default ofertaEN;